import { IS_DEV } from "@/data/constants";
import { PosthogService } from "./index";

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;

export const initializePostHog = () => {
  if (IS_DEV) {
    console.info("Disabling POSTHOG in development environment.");
    return;
  }

  if (!posthogKey) {
    console.warn("PostHog key is not set in environment variables.");
    return;
  }

  try {
    PosthogService.init(posthogKey, {
      api_host: "https://us.i.posthog.com",
      person_profiles: "always",
    });
  } catch (error) {
    // Prevent PostHog initialization errors from breaking application startup
    console.error("Failed to initialize POSTHOG:", error);
  }
};
